import { c as _c } from "react/compiler-runtime";
import FunnelStepActions from 'modules/funnels/funnel/components/funnel-actions';
import TestsIcon from 'modules/funnels/funnel/icons/tests-icon';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepTypeIcon } from 'modules/funnels/funnel/utils/get-funnel-step-type-icon';
import React from 'react';
import { FunnelStepTypeTitlesEnum } from 'shared/enums/funnel-step-type-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CheckIcon } from '@systemeio/ui/icons';
interface OverlayFunnelStepProps {
  funnelStep?: FunnelStepInterface;
}
function OverlayFunnelStep(t0) {
  const $ = _c(26);
  const {
    funnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  if (!funnelStep) {
    return null;
  }
  let t1;
  if ($[0] !== funnelStep.type) {
    t1 = getFunnelStepTypeIcon(funnelStep.type);
    $[0] = funnelStep.type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== funnelStep.name) {
    t2 = <span className="text-base font-bold">{funnelStep.name}</span>;
    $[2] = funnelStep.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = FunnelStepTypeTitlesEnum[funnelStep.type];
  let t4;
  if ($[4] !== t || $[5] !== t3) {
    t4 = t(t3);
    $[4] = t;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="text-sm font-normal">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="flex flex-col">{t2}{t5}</div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <div className="flex gap-3">{t1}{t6}</div>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== funnelStep.goalFunnelStepOfAnySplitTest) {
    t8 = funnelStep.goalFunnelStepOfAnySplitTest && <div className="absolute left-3 top-3"><CheckIcon className="stroke-[rgb(var(--fill-primary))] h-4 w-4" /></div>;
    $[15] = funnelStep.goalFunnelStepOfAnySplitTest;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== funnelStep.inRunningSplitTest) {
    t9 = funnelStep.inRunningSplitTest && <div className="absolute left-3 top-3"><TestsIcon className="stroke-[rgb(var(--fill-primary))] h-4 w-4" active={false} /></div>;
    $[17] = funnelStep.inRunningSplitTest;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== funnelStep) {
    t10 = <FunnelStepActions funnelStep={funnelStep} />;
    $[19] = funnelStep;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t11 = <li className="hover:bg-brand-primary/[0.06] border-[rgb(var(--text-primary))]/20 flex cursor-pointer justify-between border-b-[1px] px-8 py-7 last:border-b-transparent">{t7}{t8}{t9}{t10}</li>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
export default OverlayFunnelStep;